import styled from 'styled-components';
import PropTypes from 'prop-types';

import arrow from '../images/arrow.svg';

const PrimaryButton = ({
  children,
  type = 'button',
  disabled = false,
  onClick,
}) => {
  return (
    <Button type={type} disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
};

export default PrimaryButton;

const Button = styled.button`
  position: relative;
  background-color: ${props => props.theme.button.primary.backgroundColor};
  border-bottom: ${props => props.theme.button.primary.borderBottom};
  border-left: ${props => props.theme.button.primary.borderLeft};
  border-right: ${props => props.theme.button.primary.borderRight};
  border-top: ${props => props.theme.button.primary.borderTop};
  border-radius: ${props => props.theme.button.primary.borderRadius};
  font-size: ${props => props.theme.button.fontSize};
  color: ${props => props.theme.button.primary.fontColor};
  font-weight: ${props => props.theme.button.fontWeight};
  text-align: center;
  padding: ${props =>
    props.theme.button.primary.padding ?? '1.2rem 5.625rem 1.2rem 0.9375rem'};
  cursor: pointer;
  transition: 0.6s ease;

  ${props =>
    props.theme.button.primary.secondaryBackgroundColor &&
    `&:before {
      left: auto;
      right: 0;
      width: 4.6875rem;
      margin-right: 0;
      position: absolute;
      background-color: ${props.theme.button.primary.secondaryBackgroundColor};
      background-image: url(${arrow});
      top: 0;
      height: 100%;
      background-repeat: no-repeat;
      background-position: 50%;
      object-fit: cover;
      content: '';
    }`};

  &:hover {
    background-color: ${props =>
      props.theme.button.primary.hover.backgroundColor};
    border-color: ${props => props.theme.button.primary.hover.borderColor};
    color: ${props => props.theme.button.primary.hover.fontColor};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${props => props.theme.button.primary.disabled.fontColor};
    background-color: ${props =>
      props.theme.button.primary.disabled.backgroundColor};
    border-color: ${props => props.theme.button.primary.disabled.borderColor};
    opacity: ${props => props.theme.button.primary.disabled.opacity};
  }
`;
